"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var header_footer_1 = require("@shared/constants/header-footer");
var angular_1 = __importDefault(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prHeaderFooterService', [
        '$sanitize',
        'prPageHeaderFooterGenerator',
        'prActiveReport',
        'prPageLayoutService',
        'prHiddenRenderer',
        'prFlowingPages',
        'prEventService',
        function ($sanitize, headerFooterGenerator, activeReport, pageLayout, hiddenRenderer, flowingPages, eventService) {
            var CELL_SIZE = pageLayout.getCellSize();
            function getProperties() {
                return lodash_1.default.defaultsDeep({}, activeReport.getMetadata(header_footer_1.HEADER_FOOTER) || {}, header_footer_1.DEFAULT_HEADER_FOOTER);
            }
            /**
             * Saves header and footer to context meta and also re-computes height and the HTML using
             * the header-footer-generator-service.
             */
            function _setProperties(props) {
                var properties = lodash_1.default.cloneDeep(props);
                return activeReport.setMetadata(header_footer_1.HEADER_FOOTER, properties);
            }
            function getProperty(prop) {
                return getProperties()[prop];
            }
            function isDisabled(headerFooter) {
                return !headerFooter.html;
            }
            function getPXHeight(prop) {
                var headerFooter = getProperty(prop);
                var height = headerFooter.calculatedHeight;
                // Round height to cell size
                if (height / CELL_SIZE !== 0) {
                    height = Math.ceil(height / CELL_SIZE) * CELL_SIZE;
                }
                return isDisabled(headerFooter) ? 0 : height;
            }
            function getUpdatedHeight(html) {
                var preview = $('<pr-page-header-footer>')
                    .css('width', pageLayout.getWidth())
                    .html(html);
                hiddenRenderer.appendElement(preview);
                var calculatedHeight = preview.height();
                preview.remove();
                return calculatedHeight;
            }
            function updateHeaderOrFooter(type, headerFooterLayout) {
                var options = headerFooterLayout[type];
                options.calculatedHeight = getUpdatedHeight(options.html);
                _setProperties(headerFooterLayout);
                flowingPages.updateWidgetScale();
                eventService.trigger(type + "ConfigChanged");
            }
            function updateHeaderAndFooter() {
                var headerFooterLayout = getProperties();
                lodash_1.default.forEach(headerFooterLayout, function (options, headerFooter) {
                    updateHeaderOrFooter(headerFooter, headerFooterLayout);
                });
            }
            return {
                getProperties: getProperties,
                getProperty: getProperty,
                isDisabled: isDisabled,
                getPXHeight: getPXHeight,
                updateHeaderOrFooter: updateHeaderOrFooter,
                updateHeaderAndFooter: updateHeaderAndFooter
            };
        }
    ]);
})(angular_1.default.module('qualtrics.pr'));
